import React from 'react'
import { List } from 'immutable'
import Link, { TARGET_BLANK } from '../../Link/index'
import { getPrimary } from '../../../services/languages/index'
import { getHelpCenterUrl } from '../../../services/url/index'
import {
  CHECKOUT_ORDER_ERROR_TYPE_ALREADY_SUBSCRIBED,
  CHECKOUT_ORDER_ERROR_TYPE_PAYMENT,
  CHECKOUT_ORDER_ERROR_TYPE_POSTAL_CODE,
} from '../../../services/checkout/index'
import { PAYMENT_ERROR_TYPE_POSTAL_CODE } from '../../../services/payment/index'
import ErrorMessage from '../../ErrorMessage/index'

/**
 * Component to handle the payment error
 * @param {Map} props
 * @param {Map} props.user - User state
 * @param {Map} props.payment - Payment state
 * @param {Map} props.checkout - Checkout state
 * @param {Map} props.staticText - Static text translations
 * @returns {React.ReactNode}
 */
function CartSinglePagePaymentError ({
  user,
  payment,
  checkout,
  staticText,
}) {
  const userLanguage = getPrimary(user.getIn(['data', 'language'], List()))
  const checkoutOrderError = checkout.get('orderError')
  const paymentError = payment.getIn(['data', 'payments', 'success']) === false || payment.getIn(['data', 'payments', 'error']) === true
  const paymentValidationError = payment.get('error')
  const errorShouldRender = checkoutOrderError || (paymentError || paymentValidationError)
  let message = staticText.getIn(['data', 'errorGeneric'])

  if (!errorShouldRender) {
    return null
  }

  // Determine specific error message based on error type
  if (checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_PAYMENT || paymentError) {
    message = staticText.getIn(['data', 'errorPayment'])
  } else if (checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_ALREADY_SUBSCRIBED) {
    message = staticText.getIn(['data', 'errorAlreadySubscribed'])
  } else if (
    checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_POSTAL_CODE
      || paymentValidationError === PAYMENT_ERROR_TYPE_POSTAL_CODE
  ) {
    message = staticText.getIn(['data', 'errorPostalCode'])
  }

  const orderErrorMessages = [
    `${message} `,
    <Link
      key={getHelpCenterUrl(userLanguage)}
      className="cart-payment-v2__billing-error-link"
      to={getHelpCenterUrl(userLanguage)}
      directLink
      target={TARGET_BLANK}
    >
      {staticText.getIn(['data', 'customerSupport'])}
    </Link>,
  ]

  return (
    <ErrorMessage
      errorMessages={orderErrorMessages}
      errorMessageClass={['cart-payment-v2__billing-error']}
    />
  )
}

export default CartSinglePagePaymentError
